import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaArrowLeft, FaStar } from "react-icons/fa";
import { API_BASE } from "../config/api";
import "./ReviewsPage.css";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

function ReviewsPage() {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${API_BASE}/reviews/public`);
        setReviews(Array.isArray(response.data?.reviews) ? response.data.reviews : []);
      } catch (error) {
        console.error("Failed to load reviews:", error);
        setReviews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  return (
    <main className="reviews-page">
      <section className="reviews-page-hero">
        <button
          type="button"
          className="reviews-page-back-button"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
          Back
        </button>
        <span>Customer Reviews</span>
        <h1>Reviews</h1>
        <p>Read approved experiences shared by Panchali Jewels customers.</p>
      </section>

      {loading ? (
        <div className="reviews-page-state">Loading reviews...</div>
      ) : reviews.length === 0 ? (
        <div className="reviews-page-state">No approved reviews yet.</div>
      ) : (
        <section className="reviews-page-grid">
          {reviews.map((review) => (
            <article className="reviews-page-card" key={review._id}>
              <div className="reviews-page-card-head">
                <div>
                  <h2>{review.user?.name || review.name || "Customer"}</h2>
                  <p>{formatDate(review.createdAt)}</p>
                </div>
                <div className="reviews-page-stars" aria-label={`${review.rating} star rating`}>
                  {Array.from({ length: 5 }, (_, index) => (
                    <FaStar key={index} className={index < Number(review.rating) ? "is-filled" : ""} />
                  ))}
                </div>
              </div>
              <p className="reviews-page-feedback">{review.feedback}</p>
            </article>
          ))}
        </section>
      )}
    </main>
  );
}

export default ReviewsPage;
